import { render, staticRenderFns } from "./HeaderStores.vue?vue&type=template&id=613e8321"
import script from "./HeaderStores.vue?vue&type=script&lang=ts"
export * from "./HeaderStores.vue?vue&type=script&lang=ts"
import style0 from "./HeaderStores.vue?vue&type=style&index=0&id=613e8321&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports